import { css } from 'emotion'

//FORM
export const Form = css({
  '.btn': {
    marginTop: '3.75rem',
  }
})


// WEBPACK FOOTER //
// ./src/styles/form.js